import React from 'react';
import { Link } from 'react-router-dom';
export const SEOTextSection = () => {
  return <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-498" data-mp="29hhuxlbl7r1p">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-499" data-mp="29foifpeamcls">
        <div className="prose prose-invert max-w-none" data-id="element-500" data-mp="2e9srqfb16wq1">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-501" data-mp="2j7b2mb8lzm0o">
            Bij <span className="text-[#D6281F]" data-id="element-502" data-mp="2j9nimiut3mb3">BKCustoms</span> brengen wij
            jouw auto naar een hoger niveau
          </h2>
          <p className="text-white/80 mb-4" data-id="element-503" data-mp="1qinbw053c4fq">
            Met jarenlange ervaring in <strong data-id="element-504" data-mp="1qkzvsiuesovf">autostyling in Almere</strong> en
            een passie voor perfectie, biedt BKCustoms hoogwaardige diensten
            aan, waaronder{' '}
            <Link to="/diensten/autowrappen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-505" data-mp="1zkd4h9apl9f3">
              autowrapping
            </Link>
            ,{' '}
            <Link to="/diensten/ramen-tinting" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-506" data-mp="3ax5w8k3i1xv5">
              raam tinten
            </Link>
            ,{' '}
            <Link to="/diensten/lichten-smoken" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-507" data-mp="1a3szk64kopuo">
              lichten tinten
            </Link>
            , en{' '}
            <Link to="/diensten/ontchromen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-508" data-mp="w5uphcxabfkz">
              ontchromen
            </Link>
            . Wij combineren vakmanschap, de beste materialen, en een
            persoonlijke aanpak om jouw voertuig te transformeren tot een waar
            kunstwerk op wielen.
          </p>
          <p className="text-white/80 mb-8" data-id="element-509" data-mp="dfn2q5dw71qy">
            Of je nu een volledig nieuwe look wilt voor je auto of juist
            subtiele aanpassingen zoals{' '}
            <Link to="/diensten/alloygator" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-510" data-mp="8h20y1izsa0e">
              bescherming voor je velgen
            </Link>
            , BKCustoms levert altijd maatwerk met oog voor elk detail. Onze
            gespecialiseerde autostyling diensten in Almere zijn ontworpen om te
            voldoen aan de hoogste eisen, zodat jouw auto een unieke uitstraling
            krijgt.
          </p>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-511" data-mp="hkgyfo7fayc1">
            Waarom kiezen voor <span className="text-[#D6281F]" data-id="element-512" data-mp="mis3zmqoqmog">BKCustoms</span>{' '}
            in Almere?
          </h3>
          <p className="text-white/80 mb-8" data-id="element-513" data-mp="7ue3vjknlcbl">
            BKCustoms onderscheidt zich door zijn toewijding aan vakmanschap en
            kwaliteit. Ons team van ervaren professionals werkt met de nieuwste
            technieken en de beste materialen om jouw voertuig perfect af te
            leveren. Met ons{' '}
            <Link to="/diensten/maatwerk-advies" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-514" data-mp="159ryf3gy8op4">
              maatwerk
            </Link>{' '}
            transformeren we elke auto naar jouw exacte wensen. Klanten in
            Almere en omgeving waarderen onze persoonlijke service en ons
            vermogen om aan de hoogste verwachtingen te voldoen.
          </p>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-515" data-mp="2us8d4nbu4le6">
            Over <span className="text-[#D6281F]" data-id="element-516" data-mp="271ceb68yopxf">Ons</span>
          </h3>
          <p className="text-white/80 mb-4" data-id="element-517" data-mp="221zsmotttowf">
            BKCustoms is meer dan alleen een autostylingbedrijf in Almere – wij
            zijn jouw partner in het realiseren van een unieke en exclusieve
            look voor je voertuig. Ons toegewijde team combineert ervaring met
            passie, wat resulteert in niets minder dan perfectie. Elk project,
            van een complete{' '}
            <Link to="/diensten/autowrappen" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-518" data-mp="3mhjthss0sx0y">
              autowrap
            </Link>{' '}
            tot kleine verfijningen, wordt met de grootste zorg uitgevoerd.
          </p>
          <p className="text-white/80 mb-8" data-id="element-519" data-mp="vk9sl1evhcv3">
            <Link to="/over-ons" className="text-white/80 border-b border-dotted border-[#D6281F] hover:text-white/100 transition-colors" data-id="element-520" data-mp="vjguspxw5xp3">
              Lees verder over hoe BKCustoms jouw visie tot leven kan brengen
            </Link>{' '}
            en ontdek meer over ons vakmanschap en onze aanpak in Almere.
          </p>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center" data-id="element-521" data-mp="19holwh88y4sc">
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-522" data-mp="1ed3xt3mp1qm4">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-523" data-mp="1j92pp178dqra">
              Auto Wrappen Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-524" data-mp="1o748dl0qvo28">
              Premium car wrapping met hoogwaardige folies voor een unieke look.
            </p>
            <Link to="/diensten/autowrappen" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-525" data-mp="3ctmizik3185u">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-526" data-mp="33sy7aui5vjw4">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-527" data-mp="2ytbugm68w5nu">
              Ramen Tinten Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-528" data-mp="a4uijx7iz30">
              Privacy en UV-bescherming met stijlvolle raamfolie.
            </p>
            <Link to="/diensten/ramen-tinting" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-529" data-mp="3rjkd0f4p0s2y">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-530" data-mp="3hptrnj3v4xrh">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-531" data-mp="j38tmkt72450">
              Lichten Smoken Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-532" data-mp="e94irqgt5byn">
              Stijlvolle getinte lichten voor een krachtige uitstraling.
            </p>
            <Link to="/diensten/lichten-smoken" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-533" data-mp="2ckmt59mh1vhi">
              Meer informatie →
            </Link>
          </div>
          <div className="bg-[#0f0f0f] p-4 border border-[#222] rounded-md" data-id="element-534" data-mp="23r1dzp6eac7k">
            <h4 className="text-lg font-semibold text-white mb-2" data-id="element-535" data-mp="1ouaoq8qfqgvo">
              Ontchromen Almere
            </h4>
            <p className="text-white/70 text-sm" data-id="element-536" data-mp="1tu5do6qngwe3">
              Chrome delete voor een moderne, strakke look.
            </p>
            <Link to="/diensten/ontchromen" className="text-[#D6281F]/90 text-sm mt-2 inline-block hover:text-[#D6281F] transition-colors" data-id="element-537" data-mp="1fvoz5tmjq1le">
              Meer informatie →
            </Link>
          </div>
        </div>
      </div>
    </section>;
};